import React from "react";
import { Col, Row } from "react-bootstrap";

import { LineDivider } from "components/layout";
import { float2Normalizer } from "validators";

import TextBlock from "../components/textBlock";

import stylesLayout from "../../../../components/layout/layout.module.scss";

type AccessoriesViewProps = {
	terminalAccessories: { [key: string]: any };
};

const AccessoriesView = ({ terminalAccessories }: AccessoriesViewProps) => {
	return terminalAccessories?.map((item, index) => {
		const accessoryTitle = `Accessories ${index + 1}`;
		return (
			<React.Fragment key={index}>
				<Row>
					<Col xl={12}>
						<h6
							className={`${stylesLayout.viewSectionTitle} ${stylesLayout.subTitle}`}
						>
							{accessoryTitle}
						</h6>
						<Row>
							<Col xl={6}>
								<TextBlock
									label={`Accessory`}
									value={item?.type?.name}
									dataAutotest={`accessory ${index + 1}`}
								/>
							</Col>
						</Row>
						{item?.type?.name === "Other" && (
							<Row>
								<Col xl={6}>
									<TextBlock
										label={`Accessory Name`}
										value={item?.otherName}
										dataAutotest={`accessoryOtherName ${
											index + 1
										}`}
									/>
								</Col>
							</Row>
						)}
						<Row>
							<Col xl={6}>
								<TextBlock
									label="Price Per Accessory"
									value={
										float2Normalizer(item.price, "$") || ""
									}
									dataAutotest={`pricePerAccessory ${
										index + 1
									}`}
								/>
							</Col>
						</Row>
					</Col>
				</Row>

				<LineDivider className={`${stylesLayout.lineDividerHolder}`} />
			</React.Fragment>
		);
	});
};

export default AccessoriesView;
